import {
  GUARD_LOADING,
  GUARD_ERROR,
  GUARD_DEVICES_LOADED,
  GUARD_DEVICE_LOADED,
  GUARD_VERSION_DISTRIBUTION_LOADED,
  GUARD_RELEASES_LOADED,
  GUARD_CLEAR_DEVICE,
} from '../actions/guardActions';

const initialState = {
  loading: false,
  error: null,
  devices: [],
  selectedDevice: null,
  selectedDeviceEvents: [],
  versionDistribution: [],
  releases: [],
  releasePolicy: null,
  releaseEnvOverrides: {},
};

const guardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GUARD_LOADING:
      return { ...state, loading: true, error: null };

    case GUARD_ERROR:
      return { ...state, loading: false, error: action.payload };

    case GUARD_DEVICES_LOADED:
      return { ...state, loading: false, devices: action.payload };

    case GUARD_DEVICE_LOADED:
      return {
        ...state,
        loading: false,
        selectedDevice: action.payload.device,
        selectedDeviceEvents: action.payload.events,
      };

    case GUARD_VERSION_DISTRIBUTION_LOADED:
      return { ...state, versionDistribution: action.payload };

    case GUARD_RELEASES_LOADED:
      return {
        ...state,
        releases: action.payload.releases,
        releasePolicy: action.payload.policy,
        releaseEnvOverrides: action.payload.envOverrides,
      };

    case GUARD_CLEAR_DEVICE:
      return {
        ...state,
        selectedDevice: null,
        selectedDeviceEvents: [],
      };

    default:
      return state;
  }
};

export default guardReducer;
